
import React, { useEffect, useRef, useState } from "react";
import { CDN_URL, VIDEO_CDN } from "../Utils/bootstrap";
import CleverTapSdk from "../Utils/CleverTapSdk"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import $ from 'jquery'

// Images are revealed in batches so the grid and lightbox never render the full
// result set at once. PREFETCH_AHEAD appends the next batch when the user is this
// many images from the end of the loaded window (e.g. ~the 10th of a 12 batch).
const BATCH_SIZE = 12;
const PREFETCH_AHEAD = 2;

// Crisp CSS spinner shown in the lightbox while the full-size image loads.
// (The old loader.png was a faint near-white graphic, barely visible on mobile.)
const lightboxLoader = (
    <div className="ril_custom_loader">
        <div className="ril_spinner" />
    </div>
);

// Some mobile browsers finish loading the lightbox image but don't paint it
// until an interaction (tap), leaving a black frame. After the main image loads,
// nudge the current image element's opacity to force a repaint so no tap is
// needed. Double rAF waits until the library has rendered the <img>, and the
// original inline opacity is restored so nothing else is affected.
const forceLightboxRepaint = () => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const el = document.querySelector('.ril-image-current');
            if (!el) return;
            const prev = el.style.opacity;
            el.style.opacity = '0.99';
            // read layout to force a reflow before restoring
            void el.offsetHeight;
            requestAnimationFrame(() => {
                el.style.opacity = prev || '';
            });
        });
    });
};

// Build an image URL from the match's file_system_path on the resize-capable
// VIDEO_CDN. Pass a width for an Akamai-resized variant (?im=Resize,width=N);
// omit for the full image. Falls back to the old CDN + ExternalImageId when
// file_system_path is absent (older data).
const buildImageUrl = (val, width) => {
    const path = val && val.Face && val.Face.file_system_path;
    if (path) {
        return width
            ? `${VIDEO_CDN}${path}?im=Resize,width=${width}`
            : `${VIDEO_CDN}${path}`;
    }
    return val && val.Face && val.Face.ExternalImageId
        ? `${CDN_URL}${val.Face.ExternalImageId}`
        : "/assets/images/img-2.jpg";
};

// Download uses the full-resolution image (no resize) from the appvideos CDN.
// myphoto blocks browser fetch/CORS, so a blob download can't be made from it;
// appvideos allows fetch and serves the same original (4804x3288). Same helper,
// no width -> full image.
const buildDownloadUrl = (val) => buildImageUrl(val);

export const Card = ({ items, page, autoOpenLightbox }) => {
    const [showSlider, setShowSlider] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [imageArr, setImageArr] = useState([])
    const [photoIndex, setImgIndex] = useState(0);
    const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);
    const [downloading, setDownloading] = useState(false);
    const sentinelRef = useRef(null);
    // Guards the auto-open-on-mount so it fires only once (not again if the user
    // closes the lightbox and `items` re-renders).
    const autoOpenedRef = useRef(false);
    const totalCount = items && items.length ? items.length : 0;


    const downloadImage = (image) => {
        if (!image || downloading) return; // ignore repeat clicks while a download runs

        // Analytics + download-count tracking (fire-and-forget).
        try {
            window.gtag("event", `Download Photo`, { image_url: image });
        } catch (error) { }
        try {
            $.ajax({
                url: "https://d1zez9d7l5hgkm.cloudfront.net/v1/photobooth/download",
                method: "POST",
                timeout: 0,
                headers: { "Content-Type": "application/json" },
                data: JSON.stringify({ url: image }),
            });
        } catch (error) {
            console.log('error is ', error)
        }

        const filename = image.split("?")[0].split("/").pop() || "photo.jpg";

        // Inside the NaMo app webview, hand off to the app's download handler.
        const ctx = (localStorage.getItem("org_url") || "") + window.location.href;
        if (/appversionios|appversionandroid/.test(ctx)) {
            let encodedurl = encodeURIComponent(`${image}?ignore.zip`);
            window.location.href = `download://?url=${encodedurl}`;
            return;
        }

        // Desktop / mobile browser: fetch the (CORS-enabled) image as a blob and
        // trigger a real download instead of just opening it. Show a loader while
        // the (large) image downloads so the user doesn't click repeatedly.
        setDownloading(true);
        fetch(image)
            .then((res) => res.blob())
            .then((blob) => {
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = objectUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
                setDownloading(false);
            })
            .catch(() => {
                // Fallback if fetch/CORS fails — open in a new tab.
                setDownloading(false);
                window.open(image, "_blank");
            });
    }

    const setSliderOpenClose = (key) => {
        if (showSlider) {
            $('body').removeClass('body_overflow')
        } else {
            $('body').addClass('body_overflow')
        }
        setShowSlider(!showSlider)
        // Only set the index when opening on a specific image. On close no key is
        // passed, and clobbering photoIndex with undefined would leave mainSrc
        // undefined (a black lightbox) on the next open.
        if (typeof key === 'number') {
            setImgIndex(key);
        }
    }



    let images = [];

    let setImages = () => {
        let imgs = []
        items && items.length > 0 && items.map((val) => {
            // Lightbox uses a resized (width 1080) variant — sharp but light.
            imgs.push(buildImageUrl(val, 1080));
        })
        setImageArr(imgs);
    }

    useEffect(() => {
        setImages();
        setVisibleCount(BATCH_SIZE); // new result set starts from the first batch
    }, [items])

    // When rendered as the results list, open the lightbox straight away on the
    // first image so the user lands in full-screen view and can swipe next/prev.
    // Closing it (onCloseRequest) drops back to the grid behind it.
    useEffect(() => {
        if (autoOpenLightbox && !autoOpenedRef.current && items && items.length > 0) {
            autoOpenedRef.current = true;
            setImgIndex(0);
            setShowSlider(true);
            $('body').addClass('body_overflow');
        }
    }, [autoOpenLightbox, items])

    // Grid infinite scroll: reveal the next batch when the bottom sentinel
    // scrolls into view. Only active while the grid (not the lightbox) is shown.
    useEffect(() => {
        if (showSlider) return;
        const node = sentinelRef.current;
        if (!node || visibleCount >= totalCount) return;
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setVisibleCount((c) => Math.min(c + BATCH_SIZE, totalCount));
            }
        });
        observer.observe(node);
        return () => observer.disconnect();
    }, [showSlider, visibleCount, totalCount])

    return (
        <>
            {downloading && (
                <div className="download_overlay">
                    <div className="download_spinner" />
                </div>
            )}
            <ul className="card_list" >
                {!showSlider && items && items.length > 0 && items.slice(0, visibleCount).map((val, key) => {
                    // Grid displays the resized (width 460) thumbnail.
                    let imgsrc = buildImageUrl(val, 350);
                    return (
                        <li key={key}>
                            <div className="card_detail">
                                <div className="card_banner" onClick={() => setSliderOpenClose(key)}>
                                    <img src={imgsrc} className="rounded img_banner" alt="" />
                                    <img src="/assets/images/expand.svg" className="expand_icon" alt="" />
                                </div>
                                <ul className="card_content">
                                    <li>
                                        <h5>{val.Face.ExternalImageId ? val.Face.ExternalImageId.split("/").pop() : ""}</h5>
                                        {val.ImageSize && <h6>{val.ImageSize}</h6>}
                                    </li>
                                    <li onClick={() => {
                                        try {
                                            try {

                                                let ctdata = {}
                                                ctdata['PhotoBooth_action'] = 'Download_image';
                                                CleverTapSdk.handleEventtracking(ctdata)
                                            } catch (error) { }
                                        } catch (error) { }
                                    }}>
                                        <span onClick={() => downloadImage(buildDownloadUrl(val))} >
                                            <img src="/assets/images/download.svg" alt="" />
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    )
                })}
            </ul>
            {!showSlider && visibleCount < totalCount && (
                <div ref={sentinelRef} className="scroll_sentinel" style={{ height: '1px' }} />
            )}
            {showSlider && imageArr.length > 0 && (
                <Lightbox
                    mainSrc={imageArr[photoIndex]}
                    nextSrc={imageArr[(photoIndex + 1) % imageArr.length]}
                    prevSrc={imageArr[(photoIndex + imageArr.length - 1) % imageArr.length]}
                    // Show the small (460) thumbnail — already cached from the grid —
                    // instantly while the full 1080 image loads, so there's no long spinner.
                    mainSrcThumbnail={buildImageUrl(items[photoIndex], 350)}
                    nextSrcThumbnail={buildImageUrl(items[(photoIndex + 1) % imageArr.length], 350)}
                    prevSrcThumbnail={buildImageUrl(items[(photoIndex + imageArr.length - 1) % imageArr.length], 350)}
                    imageTitle={`${photoIndex + 1} of ${imageArr.length}`}
                    loader={lightboxLoader}
                    imageLoadErrorMessage="Image not available"
                    animationDuration={250}
                    imagePadding={10}
                    onImageLoad={(imageSrc, srcType) => {
                        // Fix the intermittent black-frame: repaint once the main image loads.
                        if (srcType === 'mainSrc') forceLightboxRepaint();
                    }}
                    toolbarButtons={[
                        <span
                            key="download"
                            className="ril_toolbar_download"
                            title="Download"
                            onClick={() => downloadImage(buildDownloadUrl(items[photoIndex]))}
                        >
                            <img src="/assets/images/download2.svg" alt="Download" />
                        </span>,
                    ]}
                    onCloseRequest={() => setSliderOpenClose()}
                    onMovePrevRequest={() =>
                        setImgIndex((prevIndex) => (prevIndex + imageArr.length - 1) % imageArr.length)
                    }
                    onMoveNextRequest={() =>
                        setImgIndex((prevIndex) => {
                            const next = (prevIndex + 1) % imageArr.length;
                            // Nearing the end of the loaded window (~10th of a 12 batch):
                            // append the next batch so the grid stays in sync with the lightbox.
                            if (next >= visibleCount - PREFETCH_AHEAD && visibleCount < totalCount) {
                                setVisibleCount((c) => Math.min(c + BATCH_SIZE, totalCount));
                            }
                            return next;
                        })
                    }
                />
            )}
        </>
    )
}